
import {Component, Vue} from "vue-property-decorator";
import api from '@/api'

@Component({name: 'WechatFeePercentSetting'})
export default class WechatFeePercentSetting extends Vue {

  wechatFeePercent: number = 0

  saving = false;
  loading = true;

  created() {
    api.configuration.getSplitBillWechatFeePercent().then(value => {
      this.wechatFeePercent = value;
      this.loading = false;
    })
  }

  updateValue() {
    this.saving = true
    api.configuration.updateSplitBillWechatFeePercent({wechatFeePercent: this.wechatFeePercent}).then(() => {
      this.saving = false
      this.$message.success('微信手续费比例更新成功')
    }).catch(() => {
      this.saving = false;
    })
  }

}
